import { Component } from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-how-to-apply-service',
  standalone: true,
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './how-to-apply-service.component.html',
  styleUrl: './how-to-apply-service.component.css'
})
export class HowToApplyServiceComponent {

}
